"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileSize = getFileSize;
exports.validateFile = validateFile;

var _immutable = require("immutable");

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var KB = 1024;
var MB = Math.pow(KB, 2);
var INVALID_FILE_TYPES = (0, _immutable.Seq)(['ade', 'adp', 'bat', 'chm', 'cmd', 'com', 'cpl', 'exe', 'hta', 'ins', 'isp', 'jar', 'js', 'jse', 'lib', 'lnk', 'mde', 'msc', 'msi', 'msp', 'mst', 'nsh', 'pif', 'scr', 'sct', 'shb', 'sys', 'vb', 'vbe', 'vbs', 'vxd', 'wsc', 'wsf', 'wsh']);

var getFileSizeKey = function getFileSizeKey(type) {
  return "customerDataEmail.Attachments.fileSize." + type;
};

var invalidFileType = (0, _memoize.default)(function (fileType) {
  return INVALID_FILE_TYPES.contains(fileType);
});

function getFileSize(file) {
  var size = file.get('size');

  if (size < KB) {
    return {
      key: getFileSizeKey('bytes'),
      value: "" + size
    };
  }

  if (size < MB) {
    return {
      key: getFileSizeKey('kb'),
      value: (size / KB).toFixed(2)
    };
  }

  return {
    key: getFileSizeKey('mb'),
    value: (size / MB).toFixed(2)
  };
}

function validateFile(file) {
  var extension = file.get('extension');

  if (invalidFileType(extension)) {
    return {
      key: 'contactInteraction.errors.attachments.invalidType',
      options: {
        extension: extension
      }
    };
  }

  return false;
}